export enum Sort {
  DUE_DATE = 'dueDate',
  LAST_INTERACTION_DATE_IN = 'lastInteractionDateIn',
  WAKE_UPDATE = 'wakeupDate',
  CREATION_DATE = 'creationDate',
  AGENT_ASSIGN_DATE = 'agentAssignDate',
}

export type SortValues = `${Sort}`
